var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-company"},[(_vm.isEmployee && _vm.isTeamDashboard)?_c('CardSingleCompanyLink',{staticClass:"card-company__link",attrs:{"title":_vm.account.name,"text":_vm.account.name,"to":{
      name: 'dashboard-client',
      params: { account_id: _vm.account.id },
    },"data-jest":"company-link"}}):_c('CardSingleCompanyName',{attrs:{"name":_vm.account.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }